import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqVenda = {
	listPaginate: async function (body) {
		return apiServer
			.get("portal/v1/venda/listagem", {
				params: body,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listByClient: async function (body) {
		return apiServer
			.get("portal/v1/venda/cliente", {
				params: body,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listByYear: async function (paramValue, paramDtIni, paramDtFim) {
		return apiServer
			.get("portal/v1/venda/intervalo", {
				params: {
					paramValue,
					paramDtIni,
					paramDtFim,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listByMonth: async function (paramDtIni) {
		return apiServer
			.get("portal/v1/venda/mes", {
				params: {
					paramDtIni,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	//todo passar data e hora
	listByDay: async function (paramDtIni, paramDtFim) {
		return apiServer
			.get("portal/v1/venda/dia", {
				params: {
					paramDtIni,
					paramDtFim,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listRanking: async function (params) {
		return apiServer
			.get("portal/v1/venda/ranking-clientes", {
				params: params,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listInactiveClients: async function (params) {
		return apiServer
			.get("portal/v1/venda/clientes-inativos", {
				params: params,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listColaboradorComissao: async function (params) {
		return apiServer
			.get("portal/v1/venda/colaborador-comissao", {
				params: params,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listVendaCompleta: async function (idVenda) {
		return apiServer
			.get(`portal/v2/relatorios/venda/cupom?param=id_venda&paramValue=${idVenda}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listCupom: async function (id) {
		return apiServer
			.get(`portal/v1/venda/${id}/cupom`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listLoteDetalhado: async function (ids) {
		return apiServer
			.post("portal/v1/venda/lote", ids, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	updateCliente: async function (id, idCliente) {
		return apiServer
			.patch(`portal/v1/venda/${id}/cliente`, { id_cliente: idCliente }, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	saveParcelas: async function (id, payload) {
		return apiServer
			.post(`portal/v1/venda/${id}/parcelas`, payload, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	// Reestruturação geral da venda (produtos + complementos + parcelas numa transação só)
	alteracaoGeral: async function (id, payload) {
		return apiServer
			.post(`portal/v1/venda/${id}/alteracao`, payload, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqVenda;
